import { Box, Typography } from "@mui/material";
import React from "react";
import Confetti from "react-confetti";
import { makeStyles } from "tss-react/mui";

import courseCompleteSvg from "../../../assets/images/study/courseComplete.svg";
import wellDoneBoySvg from "../../../assets/images/study/wellDoneBoy.svg";
import wellDoneGirlSvg from "../../../assets/images/study/wellDoneGirl.svg";
import arrowSvg from "../../../assets/svgs/arrow.svg";
import { useCourse } from "../../../pages/course/hooks";
import { useProfile } from "../../../pages/profile/hooks";
import { ButtonYellow } from "../../buttons";
import { updateProfile as updateProfileApi } from "../../../store/profile/profileBaseAPi";
import { ensureCourseAssigned } from "../../../pages/study/course/assignUtils";

const useStyles = makeStyles()((theme) => ({
  container: {
    textAlign: "center",
    backgroundColor: "#f0f8ff",
    position: "relative",
    minHeight: "calc(100vh - 65px)",
    width: "auto",
    fontFamily: '"Quicksand", sans-serif',
  },
  header: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: "0",
  },
  headerImage: {
    width: "100%",
  },
  bgImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 0,
    display: "none",
    [theme.breakpoints.up("lg")]: {
      display: "block",
    },
  },
  content: {
    zIndex: 1,
    position: "relative",
    fontFamily: '"Quicksand", sans-serif!important',
    height: "100%",
  },
  sectionContent: {
    marginTop: "14%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  quizName: {
    color: "rgba(255, 199, 0, 1)",
    fontWeight: "700",
    lineHeight: 1,
    fontFamily: '"ms sans serif", "Segoe UI", Tahoma, sans-serif',
    position: "relative",
    textShadow: `0px 4px 16px rgba(0, 0, 0, 0.11);`,
    fontSize: "32px",
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up("md")]: {
      fontSize: "36px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "40px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "50px",
    },
    textShadow: `-1px -1px 0 white,
                                1px -1px 0 white,
                                -1px 1px 0 white,
                                1px 1px 0 white,
                                -2px -2px 0 white,
                                2px -2px 0 white,
                                -2px 2px 0 white,
                                2px 2px 0 white,
                                -3px -3px 0 white,
                                3px -3px 0 white,
                                -3px 3px 0 white,
                                3px 3px 0 white,
                                -4px -4px 0 white,
                                4px -4px 0 white,
                                -4px 4px 0 white,
                        4px 4px 0 white`,
  },
  completionMessage: {
    fontFamily: '"Carlito", "Quicksand", "Segoe UI", Arial, sans-serif',
    textAlign: "left",
    marginBottom: 0,
    fontWeight: 600,
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.2rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.6rem",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1.9rem",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "2rem",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "2rem",
    },
  },
  actionButtonContainer: {
    position: "absolute",
    left: "50%",
    transform: "translateX(100%)",
    top: "-8px",
    [theme.breakpoints.up("lg")]: {
      top: "-5px",
      left: "52%",
    },
  },
  actionButton: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    transition: "transform 0.1s ease, box-shadow 0.1s ease",
    width: "300px",
    marginBottom: theme.spacing(2),
    "&:disabled": {
      opacity: 0.5,
      cursor: "not-allowed",
    },
    "&:not(:disabled):active": {
      transform: "scale(0.95)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "200px",
    },
  },
  buttonImage: {
    width: "100%",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  wellDone: {
    [theme.breakpoints.down("sm")]: {
      height: "230px",
    },
    [theme.breakpoints.down("md")]: {
      height: "380px",
    },
    [theme.breakpoints.down("lg")]: {
      height: "480px",
    },
  },
  container2: {
    height: "calc(100vh - 90px)",
    position: "relative",
  },
  imageContainer: {
    // display: 'flex',
    // justifyContent: 'center',
    // height: 'calc(100vh - 65px)',
  },
  textContainer: {
    position: "absolute",
    textAlign: "center",
    top: "35%",
    left: "50%",
    transform: "translateX(-50%)",
  },
  studentName: {
    marginBottom: theme.spacing(1),
    color: "rgba(255, 199, 0, 1)",
    fontWeight: "700",
    lineHeight: 1,
    fontSize: "3em", // Default font size for larger screens
    fontFamily: '"ms sans serif", "Segoe UI", Tahoma, sans-serif',
    position: "relative",
    textShadow: `
          0px 4px 16px rgba(0, 0, 0, 0.11),
          -1px -1px 0 white,
          1px -1px 0 white,
          -1px 1px 0 white,
          1px 1px 0 white,
          -2px -2px 0 white,
          2px -2px 0 white,
          -2px 2px 0 white,
          2px 2px 0 white,
          -3px -3px 0 white,
          3px -3px 0 white,
          -3px 3px 0 white,
          3px 3px 0 white,
          -4px -4px 0 white,
          4px -4px 0 white,
          -4px 4px 0 white,
          4px 4px 0 white
        `,
    [theme.breakpoints.down("xl")]: {
      fontSize: "1.7em",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "1.4em",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "1em",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.7em",
    },
  },
  completeMess: {
    fontFamily: '"Carlito", "Quicksand", "Segoe UI", Arial, sans-serif',
    marginBottom: 0,
    fontWeight: 600,
    fontSize: "1.5em", // Default font size for larger screens
    [theme.breakpoints.down("lg")]: {
      fontSize: "1em",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "1em",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "1em",
    },
  },
  completeMess2: {
    fontFamily: '"Carlito", "Quicksand", "Segoe UI", Arial, sans-serif',
    marginBottom: 0,
    fontWeight: 600,
    fontSize: "1.8em", // Default font size for larger screens
    [theme.breakpoints.down("lg")]: {
      fontSize: "1.6em",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "1.4em",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.2em",
    },
  },
}));

export const CourseComplete = ({ course }) => {
  const { profile, setProfile } = useProfile();
  const { classes } = useStyles();
  const { allCourseComplete, nextCourse } = useCourse();

  // NOTE: the old course-level "Retake the final assessment" screen (and its
  // resetCourseProgress wipe) is gone — the per-session gate retakes sessions
  // in place, so a completed course always has every session passed. If the
  // level gate still blocks (another course of the level pending), the
  // backend's nextLevel points at the course to work on and Continue simply
  // navigates there; the in-course linear lock takes over from that point.
  const nextCourseId = nextCourse?.nextLevel?.irCourseId;
  // No `nextCourseId !== course?.id` guard: a genuine level-up must still
  // advance even when the next IR level reuses the same course id (the rural
  // track currently maps the same "Animals" course across levels).
  const canAdvance = nextCourseId;

  const bumpGradeLevelFromLabel = async (nextLevelLabel) => {
    // Direct awaited API call (not the redux dispatch): the hard navigation
    // below would otherwise kill the in-flight PUT — the same lost-write bug
    // the diagnostic completion had, which left gradeLevel stale.
    const levelMatch = nextLevelLabel ? nextLevelLabel.match(/(L\d+)/) : null;
    const extractedLevel = levelMatch ? levelMatch[1] : null;
    if (extractedLevel && profile?.id && nextCourse?.newLevel) {
      try {
        await updateProfileApi({
          body: { gradeLevel: extractedLevel },
          role: "students",
          id: profile.id,
        });
        // Reflect the new level in the store + localStorage so the navbar
        // updates immediately and the value survives the hard navigation below
        // (on boot the profile slice re-inits from localStorage; loadProfile
        // only runs at login). Synchronous, so it lands before we navigate.
        const updatedProfile = { ...profile, gradeLevel: extractedLevel };
        setProfile(updatedProfile);
        localStorage.setItem("profile", JSON.stringify(updatedProfile));
      } catch (e) {
        console.error("Failed to bump gradeLevel before advancing:", e);
      }
    }
  };

  const onContinue = async () => {
    if (canAdvance) {
      await bumpGradeLevelFromLabel(nextCourse?.nextLevel?.level);
      // Make the advance durable BEFORE navigating: login opens the last
      // entry of the student's course assignments, so without this the next
      // login falls back to the finished course. Covers the login-onto-
      // completed-course path (which never runs Course.jsx's assign) and
      // backstops the live path if its earlier assign failed. Idempotent —
      // skips when the course is already assigned.
      try {
        await ensureCourseAssigned(profile?.id, nextCourseId);
      } catch (e) {
        // Navigate anyway: the backend next-ir-level self-heal points the
        // student back at their current level's course on next login.
        console.error("Failed to assign next course before advancing:", e);
      }
      // Hard navigation instead of SPA navigate(): the course/lessonPlan/
      // completion state in redux belongs to the finished course, and the
      // SPA route swap could leave this screen stuck on stale state — a
      // fresh load (which is what a manual refresh proved works) rebuilds
      // everything for the new course.
      window.location.assign(`/study/course/${nextCourseId}`);
    } else {
      window.location?.reload();
    }
  };
  const [showConfetti, setShowConfetti] = React.useState(false);
  const [windowDimension, setWindowDimension] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  React.useEffect(() => {
    const handleResize = () => {
      setWindowDimension({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  React.useEffect(() => {
    // Start confetti immediately
    setShowConfetti(true);

    const timer = setTimeout(() => {
      setShowConfetti(false);
    }, 2000); // 2 seconds duration

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box className={classes.container2}>
      {showConfetti && (
        <Confetti
          width={windowDimension.width}
          height={windowDimension.height}
          numberOfPieces={200}
          recycle={true}
          run={showConfetti}
          gravity={0.3}
          initialVelocityY={10} // Increased initial velocity
          tweenDuration={10} // Faster tween for better performance
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 1000,
            pointerEvents: "none",
          }}
        />
      )}
      <Box className={classes.imageContainer}>
        <img
          style={{ width: "100%" }}
          src={courseCompleteSvg}
          alt="congratulation"
        />
      </Box>

      <Box className={classes.textContainer}>
        <Typography className={classes.studentName} variant="h4">
            {profile?.firstName && profile?.lastName
              ? `${profile.firstName} ${profile.lastName}`
              : profile?.userName} - {profile.grade}
        </Typography>
        <Typography className={classes.completeMess} variant="h6" gutterBottom>
          {!allCourseComplete
            ? ` You've successfully completed the ${course?.courseName} course.`
            : " You've successfully completed all the courses."}
        </Typography>
        <Box>
          <img
            width={"30%"}
            src={
              profile?.gender === "FEMALE" ? wellDoneGirlSvg : wellDoneBoySvg
            }
            alt=""
          />
        </Box>
        {nextCourse?.noCourseForStudentType ? (
          <Box>
            <Typography
              className={classes.completeMess2}
              variant="h6"
              gutterBottom
            >
              No course available for this level yet — your next course is
              still being prepared. Please check back soon.
            </Typography>
          </Box>
        ) : !allCourseComplete && nextCourse?.nextLevel ? (
          <Box>
            <Typography
              className={classes.completeMess2}
              variant="h6"
              gutterBottom
            >
              {nextCourse.newLevel
                ? `Proceed to Next Level ${nextCourse.nextLevel.level.split(".")[0]}`
                : "Proceed to Next Course"}
            </Typography>
            <ButtonYellow
              sx={{
                left: "50%",
                transform: "translateX(-50%)",
                position: "absolute",
              }}
              onClick={onContinue}
            >
              <Typography
                sx={{
                  fontWeight: "700",
                  fontFamily: '"Quicksand", sans-serif',
                  fontSize: { xs: "0.8em", md: "1em", lg: "1em", xl: "1em" },
                  zIndex: 2, // Ensure the text is above the glossy effect
                }}
              >
                Continue
              </Typography>
              <img
                style={{
                  width: "15%",
                  maxWidth: "100%",
                  marginTop: "5px",
                  height: "auto",
                  zIndex: 2, // Ensure the image is above the glossy effect
                }}
                src={arrowSvg}
                alt=""
              />
            </ButtonYellow>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};
